import { isJwtExpired } from "../../utils";
import { addSentryBreadcrumb, captureRequestFailure, clearSentryUser, syncSentryUserFromToken } from "../../monitoring/sentry";

const silentAuthFailure = {
    message: false,
};

const authProvider = {
    login: ({ username, password }) =>  {
        const loginUrl = `${process.env.REACT_APP_API_URL}/auth/login`;
        const request = new Request(loginUrl, {
            method: 'POST',
            body: JSON.stringify({ email:username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    const error = new Error(response.statusText || 'Login failed');
                    error.status = response.status;
                    throw error;
                }
                return response.json();
            })
            .then(auth => {
                localStorage.setItem('token', auth.token);
                syncSentryUserFromToken();
                addSentryBreadcrumb({
                    category: 'auth',
                    message: 'User logged in',
                });
            })
            .catch((error) => {
                if (!error.status || error.status >= 500) {
                    captureRequestFailure({
                        error,
                        operation: 'login',
                        url: loginUrl,
                        method: 'POST',
                    });
                } else {
                    addSentryBreadcrumb({
                        category: 'auth',
                        message: 'Login rejected',
                        level: 'warning',
                        data: {
                            status: error.status,
                        },
                    });
                }
                throw new Error('Invalid credentials');
            });
    },
    logout: () => {
        localStorage.removeItem('token');
        clearSentryUser();
        addSentryBreadcrumb({
            category: 'auth',
            message: 'User logged out',
        });
        return Promise.resolve();
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403 ) {
            localStorage.removeItem('token');
            clearSentryUser();
            addSentryBreadcrumb({
                category: 'auth',
                message: 'Authentication error forced logout',
                level: 'warning',
                data: {
                    status,
                },
            });
            return Promise.reject();
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    checkAuth: () => {
        const token = localStorage.getItem('token');

        try {
            // Required for the authentication to work
            if (token && !isJwtExpired(token)) {
                syncSentryUserFromToken();
                return Promise.resolve();
            }
        } catch (error) {
            addSentryBreadcrumb({
                category: 'auth',
                message: 'Stored token rejected during auth check',
                level: 'warning',
                data: {
                    reason: error.message,
                },
            });
        }

        if (token) {
            localStorage.removeItem('token');
        }

        clearSentryUser();
        return Promise.reject(silentAuthFailure);
    },
    getPermissions: () => {
        // Required for the authentication to work
        return Promise.resolve();
    },
    // ...
};

export default authProvider;
